import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function PulseOfTheContinent() {
  // New Video ID: L0s-nhN5h3M
  const videoId = "L0s-nhN5h3M";
  return <section data-section-id="224523" id="the-future-of-advertising" className="relative min-h-screen flex items-center justify-center bg-black text-foreground overflow-hidden">
      {/* YouTube Background Video Container */}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden bg-black">
        <iframe className="absolute top-1/2 left-1/2 w-[115vw] h-[115vh] -translate-x-1/2 -translate-y-1/2 object-cover" src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&showinfo=0&rel=0&modestbranding=1&iv_load_policy=3&enablejsapi=1`} frameBorder="0" allow="autoplay; fullscreen" aria-hidden="true" style={{
        border: 'none'
      }} />
      </div>

      {/* Cinematic Dark Overlay */}
      <div className="absolute inset-0 bg-black/40 z-[1] pointer-events-none" aria-hidden="true" />

      {/* Radial Vignette for Depth */}
      <div className="absolute inset-0 bg-[radial-gradient(circle,_transparent_30%,_black_100%)] opacity-70 z-[2] pointer-events-none" aria-hidden="true" />

      {/* Hero Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto flex flex-col items-center gap-8">
        <h1 className="text-5xl font-bold uppercase tracking-tighter text-white drop-shadow-[0_10px_30px_rgba(0,0,0,0.8)] font-default !m-0 ![padding:0px_0px_5px_0px] md:text-7xl lg:text-9xl">
          THE FUTURE IS GENERATED
        </h1>
        
        <p className="text-xl md:text-2xl text-white/90 font-medium tracking-normal max-w-2xl drop-shadow-md font-default">
          Commercial-grade video production at the speed of thought.
        </p>
        
        <Button asChild size="lg" className="mt-6 bg-white text-black hover:bg-white/90 hover:shadow-2xl hover:shadow-white/30 hover:-translate-y-1 transition-all duration-300 text-lg h-14 px-10 rounded-lg font-bold border-0 shadow-xl">
          <Link to="#">Enter the Neural Lab</Link>
        </Button>
      </div>
    </section>;
}